import { http, camelify } from '../rest';

export function fetch(http, camelify, demo) {
  return {
    async execute() {
      let data;
      if (demo) {
        const file = await import('./fetch.data');
        data = file.default;
      } else {
        const response = await http.get('/clients');
        data = response.data;
      }
      data = data.map(client => { client.assets = Number(client.assets); return client; });
      return data.map(camelify);
    },
  };
}

export default fetch(http, camelify, process.env.DEMO);
